module.exports = __webpack_public_path__ + "img/advantage-one-stop-solution.9daa0e6e.png";